import { Radar } from "lucide-react";
import { Link } from "react-router-dom";

export function AppLogo() {
  return (
    <Link className="flex items-center gap-3" to="/dashboard">
      <div className="flex size-11 items-center justify-center rounded-2xl bg-fiscal text-fiscal-foreground shadow-panel">
        <Radar className="size-5" />
      </div>
      <div className="min-w-0">
        <p className="font-serif text-lg font-bold leading-none tracking-tight text-foreground">
          PRIMA
        </p>
        <p className="mt-1 text-xs uppercase tracking-[0.18em] text-muted-foreground">
          Intelijen Regional
        </p>
      </div>
    </Link>
  );
}
